import CheckBox from 'chameleon/ui-stack/ui/base/checkbox';
import { useTeacherOrganizeContext } from 'legacy-src/components/TeacherOrganize/hooks/useTeacherOrganize';
import React from 'react';
import { resourceTypes } from 'chameleon/legacy/src/components/TeacherOrganize/utils/constants';

const BulkTableCheckbox = ({ id = '', title = '', type = '' }) => {
  const {
    state: { isBulkMode },
    actions: { addOrRemoveBulk, checkIfResourceSelectedBulk },
  } = useTeacherOrganizeContext({});

  const isPDF = type === resourceTypes.pdf;

  return isBulkMode && !isPDF ? (
    <span className="pr-4 pt-1">
      <CheckBox
        accessibility={{
          title: checkIfResourceSelectedBulk(id)
            ? `Resource: ${title} selected for bulk label, unselect`
            : `Select resource: ${title} for bulk label`,
        }}
        checked={checkIfResourceSelectedBulk(id)}
        onClick={() => addOrRemoveBulk(id, type)}
      />
    </span>
  ) : null;
};

export default BulkTableCheckbox;
